import React from 'react';
import { Pagination } from '../Pagination';
import { MediaPlayback } from '../../model/MediaPlayback';
import { Information } from '../Information';
import { t } from '../../i18n';

// Las tres primeras son de texto (se truncan); el resto, numéricas, toman el
// ancho de su cabecera — ver .media-playback-list en broox.scss.
const columns = [
  { id: 'media', label: 'media' },
  { id: 'campaign', label: 'campaign' },
  { id: 'playlist', label: 'playlist' },
  { id: 'played', label: 'played' },
  { id: 'mediaViews', label: 'views' },
  { id: 'partially', label: 'partially' },
  { id: 'fully', label: 'fully' }
];

// Si el nombre tiene '@', solo se muestra lo anterior
const displayMediaName = (mediaName: string) => mediaName?.split('@')[0];

const List = ( { items, page, itemsPerPage, totalItems, onPageChange }: Props) => {
  return (
    <div className="border border-1 rounded-2 p-3">
      <div className="media-playback-list">
        <div className="media-playback-list__row list-header text-gray-12 fw-bold">
          {
            columns.map(column =>
              <div key={column.id} className="media-playback-list__cell">
                <div className="d-flex align-items-center">
                  <Information id={column.id} content={<small className="me-2">{t(`mediaPlayback.columns.${column.label}`)}</small>} />
                  <Information id={column.id} showMore={true} />
                </div>
              </div>
            )
          }
        </div>
        {
          items.map(item => <div key={`${item.mediaId}|${item.campaignId}|${item.playlistId}`} className="media-playback-list__row text-gray-11">
              <div className="media-playback-list__cell media-playback-list__text"><span className="text-truncate" title={displayMediaName(item.mediaName)}>{displayMediaName(item.mediaName)}</span></div>
              <div className="media-playback-list__cell media-playback-list__text"><span className="text-truncate" title={item.campaignName}>{item.campaignName}</span></div>
              <div className="media-playback-list__cell media-playback-list__text"><span className="text-truncate" title={item.playlistName}>{item.playlistName}</span></div>
              <div className="media-playback-list__cell">{item.played}</div>
              <div className="media-playback-list__cell">{item.fully + item.partially}</div>
              <div className="media-playback-list__cell">{item.partially}</div>
              <div className="media-playback-list__cell">{item.fully}</div>
            </div>
          )
        }
      </div>
      <div className="flex-grow-1 d-flex justify-content-end pe-2 mt-3">
        <Pagination page={page} itemsPerPage={itemsPerPage} totalItems={totalItems} onChange={onPageChange} />
      </div>
    </div>
  );
}

interface Props {
  items: MediaPlayback[],
  page: number,
  itemsPerPage: number,
  totalItems: number,
  onPageChange: (page: number) => void
}

export { List };
